<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h2>Gestione <b>Modelli Mansioni</b> </h2>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Tabelle</li>
            <li class="breadcrumb-item active">Modelli Mansioni</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <section class="col-md-12">

    <div class="card">
      <div class="card-header primary">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
        </h3>

      </div><!-- /.card-header -->
      <div class="card-body">
        <div class="row">
          <div class="col-lg-4 col-12">
            <div class="dx-fieldset-header">Mansioni</div>
            <dx-lookup [displayExpr]="getMansioneDisplayExpr" valueExpr="id" [searchEnabled]="true"
              [searchTimeout]="500" [dataSource]="listMansioni" placeholder="Seleziona mansione"
              (onValueChanged)="onMansioneValueChanged($event)">
            </dx-lookup>
          </div>
          @if (idMansioneSelezionata > 0) {
          <div class="col-lg-8 col-12">
            <dx-data-grid [dataSource]="dataSource" [showBorders]="true" [columnAutoWidth]="true"
              [columnHidingEnabled]="true" [showColumnLines]="true" [showRowLines]="true" [rowAlternationEnabled]="true"
              (onRowUpdating)="onUpdating($event)" (onInitNewRow)="onInitNewRow($event)"
              (onExporting)="onExporting($event)">
              <dxo-export [enabled]="true"></dxo-export>
              <dxo-editing mode="row" [allowAdding]="true" [allowUpdating]="true" [allowDeleting]="true"
                [useIcons]="true">
                <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
              </dxo-editing>
              <dxo-paging [pageSize]="10"></dxo-paging>
              <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
              <dxo-filter-row [visible]="true"></dxo-filter-row>
              <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>
              <dxi-column dataField="id" [formItem]="{ visible: false }" [visible]="false" [allowEditing]="false">
              </dxi-column>
              <dxi-column dataField="idTipoArticolo" caption="Tipo Articolo">
                <dxo-lookup [dataSource]="listTipiArticoli" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
              </dxi-column>
              <dxi-column dataField="note">
              </dxi-column>
            </dx-data-grid>
          </div>
          }
        </div>
      </div>
    </div>
  </section>


</div>